/**
 * CVC Customer Page
 * Main page component that renders the CVC Customer dashboard
 */

import React from "react";
import { CVCCustomerContainer } from "../components/CVCCustomer/CVCCustomerContainer";

const CVCCustomerPage: React.FC = () => {
    return (
        <div style={{ minHeight: "100vh" }}>
            <CVCCustomerContainer />
        </div>
    );
};

export default CVCCustomerPage;
